<template>
  <generic-modal :title="$t('payment')" :buttons="buttons" ref="generic_modal">
    <form>
      <div
        class="field"
        v-for="(payment_method, pidx) in payment_methods"
        :key="pidx"
      >
        <label class="label">{{ payment_method.name }}</label>
        <div class="control">
          <div class="field has-addons">
            <p class="control has-icons-left">
              <input
                class="input"
                type="text"
                :placeholder="pending"
                v-model="payment_methods[pidx].amount"
              />
              <span class="icon is-small is-left">
                {{ get_currency_settings().symbol }}
              </span>
            </p>
            <p
              class="control"
              v-if="
                payment_method.percentage_of_use &&
                payment_method.percentage_of_use > 0
              "
            >
              <a class="button is-static">
                {{ payment_method.percentage_of_use }}% {{ $t("charge") }}
              </a>
            </p>
            <p
              class="control"
              v-if="
                payment_method.amount &&
                payment_method.percentage_of_use &&
                payment_method.percentage_of_use > 0
              "
            >
              <a class="button is-static">
                {{
                  format_currency(
                    Number(payment_method.amount) +
                      (Number(payment_method.amount) *
                        Number(payment_method.percentage_of_use)) /
                        100
                  )
                }}
                {{ $t("total") }}
              </a>
            </p>
            <p
              class="control"
              v-if="
                module_settings.integrate_visanet_payment &&
                payment_method.link_to_visanet_payment
              "
            >
              <div
                class="button"                
                @click="
                  $emit(
                    'visanet_payment',
                    Number(payment_method.amount) +
                      (Number(payment_method.amount) *
                        Number(payment_method.percentage_of_use)) /
                        100
                  )
                "
              >
                {{ $t("visanet payment") }}
              </div>
            </p>
            <p class="control" v-if="payment_method.ask_for_document_number">
              <input
                class="input"
                type="text"
                :placeholder="$t('document number')"
                v-model="payment_methods[pidx].document_number"
              />
            </p>
          </div>
        </div>
      </div>
    </form>
    <p class="buttons is-pulled-right mt-5">
      <a class="button is-static is-size-5 has-text-warning">
        {{ format_currency(meta.products_data?.total_amount) }} <br />
        {{ $t("total to pay") }}
      </a>
      <a class="button is-static is-size-5 has-text-success"
        >{{ format_currency(total_payment) }} <br />
        {{ $t("payment") }}
      </a>
      <a class="button is-static is-size-5 has-text-danger" v-if="pending >= 0">
        {{ format_currency(pending) }} <br />
        {{ $t("pending") }}
      </a>
      <a class="button is-static is-size-5 has-text-info" v-if="pending < 0">
        {{ format_currency(Math.abs(pending)) }} <br />
        {{ $t("change") }}
      </a>
    </p>
    <!-- <pre>{{ meta }}</pre> -->
    <!-- <pre>{{ $props.module_settings }}</pre> -->
    <div class="notification is-danger mt-5" v-if="error">
      <p v-html="error"></p>
    </div>
  </generic-modal>
</template>
<script>
import {
  put,
  error_message,
  get,
  post,
  error_alert,
  generate_error_message_text,
  get_currency_settings,
  format_currency,
} from "@/utils";
import GenericModal from "@/components/generic_modal/Index.vue";

export default {
  name: "CreateProductModal",
  components: { GenericModal },
  props: {
    module_settings: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      buttons: [
        {
          text: this.$t("register payment"),
          class: "is-primary is-rounded",
          icon: "fa fa-credit-card",
          click: this.save,
        },
        {
          text: this.$t("cancel"),
          class: "is-rounded",
          icon: "fa fa-close",
          click: this.close_modal,
        },
      ],
      meta: {},
      error: "",
      payment_methods: [],
      // uuid: "",
    };
  },
  computed: {
    is_form_invalid() {
      let v = this;
      // return false;
      return v.pending > 0 || v.payment_methods.find((pm) => pm.amount && isNaN(pm.amount));
    },
    total_payment() {
      let v = this;
      return v.payment_methods.reduce((acc, pm) => {
        if (pm.amount) return acc + Number(pm.amount);
        else return acc;
      }, 0);
    },
    pending() {
      let v = this;
      return v.meta.products_data?.total_amount - v.total_payment;
    },
  },
  methods: {
    get_currency_settings,
    format_currency,
    close_modal() {
      let v = this;
      v.$refs.generic_modal.close_modal();
      v.set_initial_state();
    },
    show_modal(products_data) {
      // console.log("products_data", products_data);
      let v = this;
      v.set_initial_state();
      v.meta.products_data = products_data;
      v.payment_methods = JSON.parse(
        JSON.stringify(v.$props.module_settings.payment_methods || [])
      );
      v.$refs.generic_modal.show_modal();
    },
    save() {
      let v = this;
      let products = v.meta.products_data.products.map((p) => {
        return {
          i: p.product_id,
          p: p.sale_price,
        };
      });
      let filtered_payment = v.payment_methods
        .filter((pm) => {
          return pm.amount && pm.amount > 0;
        })
        .map((pm) => {
          return {
            name: pm.name,
            amount: pm.amount,
            document_number: pm.document_number,
          };
        });

      put("/gym_pos/sale", {
        products: products,
        total: v.meta.products_data.total_amount,
        payment: filtered_payment,
      })
        .then(() => {
          v.$emit("success");
          v.$refs.generic_modal.close_modal();
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
    set_initial_state() {
      let v = this;
      v.meta = {
        // name: "",
        // barcode: "",
        // sale_price: "",
        // settings: {},
      };
      v.payment_methods = [];
      v.error = "";
      // v.uuid = "";
    },
  },
  mounted() {},
  watch: {
    is_form_invalid() {
      let v = this;
      v.buttons[0].disabled = v.is_form_invalid;
    },
  },
};
</script>
<style></style>
